import Axios from "../../configs/axios.config";

export const globalSearch = (search) => Axios.get(`/common/global-search?query=${search}`);
// export const requestFileContent = (data) => Axios.post("/common/content/request", data)
export const requestFileContent = (data) => Axios.post("/service/upload-chunk", data)

export const uploadFileChunk = (id, formdata) => Axios.post(`/common/content/chunk/${id}`, formdata);
export const addUpdateFCMToken = (data) => Axios.post(`/auth/update-device`, data);
export const getFormByModule = (module, params) => Axios.get(`/form/${module}`, { params }).then((res) => res?.data?.data);
export const exportByModule = (module) => Axios.post(`/export/${module}`).then((res) => res?.data?.data);
export const ImportByModule = (module, formdata) => Axios.post(`/import/${module}`, formdata);
export const fileSampleByModule = (module, params) => Axios.get(`/sample/${module}`, { params }).then((res) => res.data.data);

export const deleteMedia = (uuid) => Axios.delete(`/media/${uuid}`);

export const getLogsList = (params) => Axios.get(`/common/logs`, { params }).then((res) => res.data.data);
export const getNotificaionList = (params) => Axios.get(`/notification`, { params }).then((res) => res.data);

export const getPreAdmissionInfo = (id) => Axios.get(`/pre-admission-enquiry/initial-data/${id}`,).then((res) => res.data.data);

export const getImportData = () => Axios.get(`/default-import-data`).then((res) => res.data.data);

// export/import user
export const ImportByUser = (formdata) => Axios.post(`/user/import`, formdata);